import { render, staticRenderFns } from "./EditPrice.vue?vue&type=template&id=e5d4010c&scoped=true&"
import script from "./EditPrice.vue?vue&type=script&lang=js&"
export * from "./EditPrice.vue?vue&type=script&lang=js&"
import style0 from "./EditPrice.vue?vue&type=style&index=0&id=e5d4010c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d4010c",
  null
  
)

component.options.__file = "EditPrice.vue"
export default component.exports